import en from "./en";
import { LOCALES } from "./locales";

const messages = {
  [LOCALES.ENGLISH]: en,
};

export default messages;
